// extracted by mini-css-extract-plugin
export default {"amount":"ProjectTransferConfirmModal_amount__XwabH"};